import { useEffect, useReducer, useRef } from "react";
import localizationStrings from "../statics/localization";
import { languageCode } from "./uiLanguage";
import { automaticTranslation } from "./automaticTranslation";

// Existing CMS/dictionary translations are supplied as preferredText when available.
// Requests start after render, and only components using a completed text rerender.
export function useTextTranslation() {
  const target = languageCode(localizationStrings.getLanguage());
  const [, redraw] = useReducer(n => n + 1, 0);
  const needed = useRef(new Map());
  needed.current = new Map();
  useEffect(() => automaticTranslation.subscribe(keys => {
    if (keys.some(key => needed.current.has(key))) redraw();
  }), []);
  useEffect(() => { needed.current.forEach(text => automaticTranslation.request(text, target)); });
  return (text, preferredText) => {
    if (typeof preferredText === "string" && preferredText.trim()) return preferredText;
    if (typeof text !== "string") return text;
    needed.current.set(automaticTranslation.keyFor(text, target), text);
    return automaticTranslation.read(text, target);
  };
}
